import i18n from "i18n";

export const resultMessages = {
  deleteResult: i18n.t('notifications.result.deleteResult'),
  deleteAllResult: i18n.t('notifications.result.deleteAllResult')
};
